import { NavLink } from "react-router-dom";
import styled from "styled-components";

interface BooksHeaderLinkProps {
  notification?: string;
}

export const BooksHeaderWrapper = styled.div`
  width: 100%;
  margin-left: 12px;

  ${(props) => props.theme.sm`
    display: none;
  `}
`;

export const BooksHeaderLink = styled(NavLink)<BooksHeaderLinkProps>`
  position: relative;
  margin-left: 12px;
  letter-spacing: 0.5px;
  text-decoration: none;
  padding: 10px 16px;
  border-radius: 7px;
  font-weight: 500;
  line-height: 1;
  transition: background-color 0.2s, color 0.2s;
  color: ${(props) => props.theme.navText};

  &:hover {
    background-color: ${(props) => props.theme.subtleHover};
  }

  &:nth-last-child(2) {
    margin-right: auto;
  }

  &::before {
    content: "";
    position: absolute;
    transform: scale(0);

    ${(props) =>
      props.notification &&
      `
      content: '${props.notification}';
      transform: scale(1);
    `};

    transition: transform cubic-bezier(0, 0, 0.7, 2.5) 0.3s;
    background-color: ${(props) => props.theme.red};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    color: ${(props) => props.theme.buttonFilledText};
    right: -5px;
    top: -4px;
    width: 17px;
    height: 17px;
    border-radius: 50%;
  }

  &.active {
    background-color: ${(props) => props.theme.activeBg};
    color: ${(props) => props.theme.activeText};
    box-shadow: ${(props) => props.theme.activeShadow};
    text-shadow: ${(props) => props.theme.activeTextShadow};
    border: ${(props) => props.theme.activeBorder};
    font-weight: 600;

    &::before {
      display: none;
    }
  }
`;
